/**
 * The hover target inside a greyed day column. Carries its day's all-day
 * titles as a data attribute; `AllDayBlockedHoverTooltip` reads them off the
 * cursor's hit-test stack and does the rendering.
 *
 * Deliberately NOT an anchored tooltip: the wash spans the whole 24h column,
 * so a Radix trigger of that height positions its card at the top of the
 * column — nowhere near where the user is actually pointing.
 *
 * Presentational only — the caller owns the wash itself (an FC background
 * event in the time grids, an absolutely-positioned box on the day board) and
 * passes the titles it already resolved for the chips.
 */
import { Box } from '@chakra-ui/react';
import { encodeAllDayTitles } from './allDayBlockedOverlay';
import './allDayBlockedOverlay.css';

export interface AllDayBlockedWashProps {
  titles: string[];
}

export function AllDayBlockedWash({ titles }: AllDayBlockedWashProps) {
  if (titles.length === 0) return null;
  return (
    <Box
      className="im-all-day-blocked-fill"
      data-all-day-titles={encodeAllDayTitles(titles)}
    />
  );
}
